<template>
  <div id="app "> 
    <router-view/>
  </div>
</template>
<script>
// import Header from './components/header.vue';
// let urls="http://192.168.1.136:8081";
export default {
  name: 'App',
  //  components: {
  //   Header: Header
  // }
}
</script>

<style>
	
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue